





import { defineComponent, watch } from '@vue/composition-api';
import { useQuery, useResult } from '@vue/apollo-composable';
import { useProjectTailwindColors } from '@ideavivat/vivat-2';

import getCompany from '@/gql/company/getCompany.gql';

const App = defineComponent({
  setup() {
    const { result: companyResult } = useQuery(getCompany);
    const projectColor = useResult(companyResult, { logoUrl: '/logo_fast.svg', backgroundUrl: '/img/background/bg-tms.png', colors: [] }, (data: any) => data.company);

    let hasRan = false;

    watch(projectColor, (newValue: any) => {
      if (!newValue) return;
      if (newValue?.colors) {
        const hashKey = 'tms-company-color-hash';
        const storedJsonColors = localStorage.getItem(hashKey);
        const jsonColors = JSON.stringify(newValue.colors);
        if (jsonColors !== storedJsonColors || !hasRan) {
          const root = document.documentElement;
          newValue.colors.forEach((color: any) => {
            root.style.setProperty(`--color-${color.key}`, color.colorCode);
          });
          console.log('cache rebuilding');
          useProjectTailwindColors(true); // refresh vivat cache
          localStorage.setItem(hashKey, jsonColors);
          hasRan = true;
        } else {
          console.log('skip cache rebuilding');
        }
      }
    });

    return {};
  },
});
export default App;
